import React from 'react';
import PropTypes from 'prop-types';

import G1LoginTop from './components/organisms/G1-login-top';
import G1LoginBottom from './components/organisms/G1-login-bottom';

import './G1-login.scss';

const Login = (props) => {
	const { view, callbacks, data } = props;
	let section = null;

	if (view === 'top') section = <G1LoginTop data={{ ...data }} callbacks={{ ...callbacks }} />;
	if (view === 'bottom') section = <G1LoginBottom data={{ ...data }} />;

	return (
		<React.Fragment>
			{ section }
		</React.Fragment>
	);
};

Login.defaultProps = {
	callbacks: {},
};

Login.propTypes = {
	view: PropTypes.string.isRequired,
	data: PropTypes.shape({}).isRequired,
	callbacks: PropTypes.shape({}),
};

export default Login;
